<template>
  <div class="pt-4">
    <ul class="text-body-2 mb-3">
      <li>Photo total score: {{ photo.percentageScore }}%</li>
      <template v-if="photo.statusName === types.photo.status.inCuration">
        <li>
          Total curations:
          {{ photo.numberOfPeopleCurationClient || 0 }}
        </li>
        <li>Published votes: {{ photo.publishNumberOfVotes || 0 }}</li>
        <li>Rejected votes: {{ photo.rejectNumberOfVotes || 0 }}</li>
      </template>
      <li v-if="photo.statusName === types.photo.status.upcoming">
        Promote number of votes:
        {{
          photo.numberOfPromoteVotes >= photo.numberOfVoteToBePromoted
            ? photo.numberOfVoteToBePromoted
            : photo.numberOfPromoteVotes || 0
        }}
        /
        {{ photo.numberOfVoteToBePromoted }}
      </li>
      <li v-if="photo.statusName === types.photo.status.prime">
        Promote to Elite number of votes:
        {{
          photo.numberOfPromoteVotesElite >= photo.numberOfVoteToBePromotedElite
            ? photo.numberOfVoteToBePromotedElite
            : photo.numberOfPromoteVotesElite || 0
        }}
        /
        {{ photo.numberOfVoteToBePromotedElite }}
      </li>
    </ul>
    <v-dialog v-model="curatorNotesDialog" width="600">
      <template #activator="{ on }">
        <v-badge
          :value="photo.hasCuratorNotes"
          bordered
          color="error"
          offset-x="5"
          offset-y="5"
          dot
          overlap
        >
          <v-btn outlined small v-on="on">
            <v-icon x-small class="mr-2">
              fal fa-clipboard
            </v-icon>
            Notes
          </v-btn>
        </v-badge>
      </template>
      <v-card outlined>
        <v-card-title class="text-h5" primary-title>
          Curator notes
        </v-card-title>
        <v-card-subtitle>
          <p class="text-body-2 mb-0 mt-3">
            Notes are only visible to curators and they don't affect photo
            popularity.<br />All curators will be notified.
          </p>
        </v-card-subtitle>
        <v-card-text>
          <v-form
            ref="form"
            v-model="formNoteValid"
            lazy-validation
            novalidate
            @submit.prevent="noop"
          >
            <h4 class="mb-1">Submit a note</h4>
            <v-textarea
              v-model="note"
              :rules="noteRules"
              outlined
              rows="2"
              placeholder="Curation note"
            />
            <div class="text-right">
              <v-btn
                :loading="postingNote"
                :disabled="!formNoteValid"
                type="submit"
                small
                depressed
                dark
                class="mt-n3"
                @click="postNote"
              >
                Submit
              </v-btn>
            </div>
          </v-form>
          <v-divider class="mt-4" />
          <v-list v-if="!loadingNotes && notes.length > 0" class="ml-n4">
            <template v-for="(n, index) in notes">
              <v-list-item :key="`${n.userId}-${index}`">
                <v-list-item-avatar class="align-self-start">
                  <v-img :src="n.avatar" :alt="`${n.fullName} avatar.`"></v-img>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ n.fullName }}
                  </v-list-item-title>
                  <v-list-item-subtitle class="text-normal">
                    {{ n.body }}
                  </v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
              <v-divider
                v-if="notes.length > index + 1"
                :key="index"
                inset
              ></v-divider>
            </template>
          </v-list>
          <div v-else-if="!loadingNotes && notes.length === 0" class="mt-3">
            No curator notes yet...
          </div>
          <div v-else class="text-center">
            <v-icon class="fa-spin my-3">
              fal fa-spinner
            </v-icon>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { curatorNotesMixin } from '@/mixins/curatorNotesMixin'
import types from '@/utils/types'

export default {
  name: 'CurationPanelCuratorNotes',
  mixins: [curatorNotesMixin],
  props: {
    me: {
      type: [Object, Boolean],
      default: () => {}
    },
    photo: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      types
    }
  }
}
</script>
